import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { SingleColumnDropdown } from '@grandvisionhq/forms';

const PowerDropdown = ({ label , options , selectedSize , onChange , className , 'data-t': dataT = 'power-dropdown' ,  })=>{
    const [selected, setSelected] = React.useState(selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.label);
    const mappedOptions = React.useMemo(()=>Object.entries(options).reduce((acc, [_, option])=>swcHelpers.objectSpread({}, acc, {
                [option.label]: option.label
            })
        , {})
    , [
        options
    ]);
    const handleSelect = React.useCallback((itemValue)=>{
        const selectedItem = options[itemValue];
        if (!selectedItem) return console.warn(`Cannot find ${itemValue} in provided options`);
        setSelected(selectedItem.label);
        onChange(selectedItem);
    }, [
        setSelected,
        onChange,
        options
    ]);
    return /*#__PURE__*/ React.createElement(SingleColumnDropdown, {
        label: label,
        className: className,
        selectedValue: selected,
        onChange: handleSelect,
        options: mappedOptions,
        "data-t": dataT
    });
};

export { PowerDropdown };
//# sourceMappingURL=PowerDropdown.js.map
